import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, ToDoHeading } from "../../../Constants/Constants";
import ToDoBody from "./ToDoBody/ToDoBody";
import ToDoSidebar from "./ToDoSidebar/ToDoSidebar";

const ToDoContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ToDoHeading} parent={Apps} />
      <Container fluid className="email-wrap bookmark-wrap todo-wrap">
        <Row>
          <ToDoSidebar />
          <ToDoBody />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ToDoContainer;
